var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlocksWatchTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1060 768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .j {\n        fill: none;\n      }\n\n      .k {\n        fill: #fcfcfc;\n      }\n\n      .l {\n        fill: #fff;\n      }\n\n      .m, .n, .o {\n        fill: #fffe67;\n      }\n\n      .bg {\n        fill: #0b0e11;\n      }\n      .p {\n        fill: #fffea4;\n      }\n\n      .q {\n        fill: #7fe0c1;\n      }\n\n      .r {\n        fill: #a169ee;\n      }\n\n      .s {\n        fill: #b98ef2;\n      }\n\n      .t {\n        fill: #b2ecda;\n      }\n\n      .u {\n        fill: #dce5ff;\n      }\n\n      .v {\n        fill: #d1daf9;\n      }\n\n      .w, .x {\n        fill: #e20100;\n      }\n\n      .y, .z, .aa {\n        fill: #1748e2;\n      }\n\n      .ab {\n        fill: #25252d;\n      }\n\n      .ac {\n        fill: #1136aa;\n      }\n\n      .ad {\n        fill: #181a1f;\n      }\n\n      .ae, .af {\n        fill: #a2b6f3;\n      }\n\n      .ag {\n        fill: #8a43ea;\n      }\n\n      .ah {\n        fill: #840405;\n      }\n\n      .ai {\n        fill: #7491ee;\n      }\n\n      .aj {\n        fill: #5fd8b2;\n      }\n\n      .z, .af {\n        mix-blend-mode: multiply;\n      }\n\n      .af {\n        opacity: .8;\n      }\n\n      .ak {\n        clip-path: url(#i);\n      }\n\n      .al {\n        clip-path: url(#g);\n      }\n\n      .am {\n        clip-path: url(#f);\n      }\n\n      .an {\n        isolation: isolate;\n      }\n\n      .aa {\n        opacity: .6;\n      }\n\n      .n, .ao, .ap, .x {\n        opacity: .9;\n      }\n\n      .ao {\n        fill: #434356;\n      }\n\n      .ap {\n        fill: #131318;\n      }\n\n      .o {\n        opacity: .86;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 755.33,
    y: 162.03,
    width: 184.24,
    height: 184.24,
    rx: 41.95,
    ry: 41.95,
    transform: "translate(1694.9 508.31) rotate(180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M861.24,268.64c2.28-.74,4.27-2.07,6.15-3.53,1.67-1.29,3.42-3.78,5.82-3.04,1.3,.4,2.29,1.51,2.87,2.74,1.28,2.73,1.57,6.23,.89,9.14-1.59,6.85-3.26,12.53-12.91,12.89s-18.7-8.1-16.03-14.01c1.65-3.64,4.95-3.73,8.41-3.57,1.77,.08,3.34-.16,4.8-.63Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 772.11,
    y: 439.9,
    width: 170.01,
    height: 170.01,
    rx: 42.11,
    ry: 42.11,
    transform: "translate(1714.23 1049.81) rotate(180)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "an"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "b",
    "data-name": "background-change-color",
    className: "bg",
    width: 1060,
    height: 768
  }), /*#__PURE__*/React.createElement("rect", {
    id: "c",
    "data-name": "TV",
    className: "ab",
    x: 278.45,
    y: 200.39,
    width: 527.68,
    height: 301.98,
    rx: 43.16,
    ry: 43.16
  }), /*#__PURE__*/React.createElement("g", {
    id: "d",
    "data-name": "Planeta"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M787.26,255.28v192.21c0,18.58-15.07,33.65-33.66,33.65H330.98c-18.59,0-33.65-15.07-33.65-33.65V255.28c0-18.59,15.06-33.65,33.65-33.65h422.62c9.39,0,17.88,3.84,23.98,10.04,.05,.04,.08,.08,.12,.12,5.91,6.06,9.56,14.35,9.56,23.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M777.7,231.79c5.91,6.06,9.56,14.35,9.56,23.49v118.51c-16.6,17.61-36.14,32.4-57.84,43.59-26.71,13.77-56.7,22.07-88.48,23.44-3.11,.14-6.24,.21-9.39,.21-37.23,0-72.24-9.51-102.72-26.24-40.64-22.28-73.26-57.39-92.4-99.88-8.27-18.35-14.02-38.09-16.82-58.76-1.3-9.49-1.96-19.18-1.96-29.02,0-1.84,.02-3.67,.07-5.5h335.88c9.39,0,17.88,3.84,23.98,10.04,.05,.04,.08,.08,.12,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M828.13,297.7c-.02,.12-.03,.16,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M828.88,293.02l.48-3.03c-.18,1.15-.34,2.16-.48,3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M829.36,289.99c.11-.69,.23-1.44,.36-2.24l-.36,2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M836.44,232.73c.01,.23,.01,.46,.01,.69,0,7.51-.39,14.93-1.16,22.24,.97-10.78,1.13-20.15,1.15-22.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M836.45,231.89s0,.2-.01,.58c.01-.2,.01-.39,0-.58h.01Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M605.67,369.98c0,7.76,3.15,14.81,8.25,19.9,5.09,5.1,12.14,8.25,19.9,8.25h123.82c-8.85,7.14-18.28,13.59-28.22,19.25-27.49,15.66-58.82,25.33-92.24,27.24h-.01c-4.07,.23-8.15,.35-12.27,.35-13.89,0-27.5-1.35-40.64-3.9-18.35-3.57-35.86-9.52-52.18-17.51-24.56-12-46.44-28.63-64.5-48.75-15.81-17.57-28.71-37.78-37.94-59.9h117.26c8.11,0,15.45-3.29,20.77-8.6,5.31-5.32,8.6-12.66,8.6-20.77,0-16.23-13.15-29.39-29.37-29.39h-132.33c-.81-7.47-1.21-15.05-1.21-22.73,0-3.96,.11-7.89,.33-11.79h339.91c9.39,0,17.88,3.84,23.98,10.04h-69.13c-14.68,0-26.57,11.91-26.57,26.58,0,7.34,2.97,13.98,7.78,18.79s11.45,7.78,18.79,7.78h20.76c15.73,0,28.5,12.77,28.5,28.5,0,7.88-3.19,15-8.36,20.16-5.14,5.16-12.28,8.34-20.14,8.34h-95.39c-1.26,0-2.51,.08-3.73,.25h-.01c-13.78,1.83-24.41,13.62-24.41,27.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M777.7,231.79c5.91,6.06,9.56,14.35,9.56,23.49v113.75c-8.89,10.64-18.81,20.39-29.62,29.1h-123.82c-7.76,0-14.81-3.15-19.9-8.25-5.1-5.09-8.25-12.14-8.25-19.9,0-14.29,10.64-26.09,24.42-27.91,1.22-.17,2.47-.25,3.73-.25h95.39c7.86,0,15-3.18,20.14-8.34,5.17-5.16,8.36-12.28,8.36-20.16,0-15.73-12.77-28.5-28.5-28.5h-20.76c-7.34,0-13.98-2.97-18.79-7.78s-7.78-11.45-7.78-18.79c0-14.67,11.89-26.58,26.57-26.58l69.25,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M576.27,285.54c0,8.11-3.29,15.46-8.6,20.77-5.31,5.31-12.66,8.6-20.77,8.6h-117.26c-7.71-18.41-12.87-38.15-15.07-58.76h132.33c16.22,0,29.37,13.16,29.37,29.39Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "ao",
    cx: 592.23,
    cy: 396.21,
    r: 66.06
  })), /*#__PURE__*/React.createElement("g", {
    id: "e",
    "data-name": "alienuno"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ab",
    x: 755.63,
    y: 161.88,
    width: 184.24,
    height: 184.24,
    rx: 42.11,
    ry: 42.11,
    transform: "translate(1695.5 508.01) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "am"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M936.47,363.16c-1.34-15.62-31.84-49.8-46.74-54.68s-31.96-1.27-44.51,8.12c-11.39,8.51-32.21,44.22-33.85,53.21h56.64l39.21-1.09"
  })), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M875.91,221.67s0,.01,0,.02c0,0,0-.01,0-.02h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M843.61,225.33c2.24-4.13,2.54-9.27,.79-13.63-1.75-4.36-5.52-7.86-10-9.29-3.03-.97-6.27-1.01-9.44-1.28-5.09-.43-13.37-2.76-12.8-9.51,.2-2.38,2.05-4.23,3.62-6.03,1.57-1.8,3.05-4.16,2.32-6.44-.79-2.48-3.96-3.51-6.48-2.84-8.25,2.19-13.61,14.53-9.02,21.93,3.42,5.52,11.48,6.33,17.34,7.32,3.6,.61,7.58,1.46,9.67,4.45,2.4,3.43,1.32,7.72,1.91,11.57,.43,2.76,1.9,4.26,3.34,6.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M873.59,229.54c4.7-.19,9.26-2.56,12.11-6.3,2.85-3.74,3.93-8.77,2.86-13.35-.72-3.1-2.34-5.9-3.73-8.76-2.23-4.59-4.47-12.89,1.62-15.86,2.15-1.05,4.68-.41,7.03,.02s5.14,.49,6.72-1.3c1.72-1.95,.99-5.2-.88-7.02-6.1-5.97-19.45-4.26-23.46,3.47-2.99,5.77,.44,13.1,2.58,18.64,1.32,3.4,2.63,7.26,1.13,10.58-1.72,3.82-5.96,5.08-8.96,7.56-2.15,1.78-2.69,3.82-3.95,6.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M822.96,274.47c3.51,11.68,10.73,21.21,21.91,26.08,11.19,4.87,32.14-.91,41.58-8.63,8.15-6.66,10.18-19.89,7.25-30.49-.36-1.3,1.17-2.29,2.2-1.42,13.83,11.51,31.86,23.33,48.81,26.44,14.73,2.7,31.92,1.37,41.71-9.96,6.89-7.98,8.54-19.87,4.86-29.74-3.69-9.88-12.31-17.57-22.29-20.97-23.13-7.88-48.57,6.37-72.63,2.14-.39-.07-.77-.14-1.16-.22-7.49-2.73-7.03-7.63-10.12-9.62-3.22-2.06-8.21-.11-9.17,3.59,0,0,0,.01,0,.02,0,0,0-.01,0-.02-.46-3.46-3.38-6.44-6.83-6.97-3.17-.49-8.49,4.35-8.61,4.62-3.05-5.86-8.69-5.2-11.68-4.29-2.82,.86-5.49,3.14-4.31,9.15-.4-3.66-4.17-5.66-9.03-4.44-3.14,.78-7.85,4.71-7.06,8.63,.78,3.92,0,4.71,3.92,5.49-7.85,.78-9.88,9.27-10.98,13.34-2.3,8.49-.92,18.83,1.62,27.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M917.69,242.93c5.58-.48,11.42-.93,16.46,1.91,2.12,1.2,3.89,3.03,4.85,5.28,2.99,7-3.17,12.41-9.25,12.93-4.63,.4-9.15-1.42-13.27-3.56-4.97-2.59-10.46-5.84-14.88-9.79-2.31-2.07-1.16-5.84,1.92-6.22,4.8-.6,10.75-.25,14.17-.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M861.24,268.64c2.28-.74,4.27-2.07,6.15-3.53,1.67-1.29,3.42-3.78,5.82-3.04,1.3,.4,2.29,1.51,2.87,2.74,1.28,2.73,1.57,6.23,.89,9.14-1.59,6.85-3.26,12.53-12.91,12.89s-18.7-8.1-16.03-14.01c1.65-3.64,4.95-3.73,8.41-3.57,1.77,.08,3.34-.16,4.8-.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "al"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M876.96,273.95s-4.25-6.62-11.27-1.96c-7.02,4.66-4.5,11.76-3.55,14.8,4.61,.68,7.67-.8,10.67-2.9s4-5.96,4.15-9.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M856.6,286.49s3.37-6.02,9.79-4.46c0,0-.27-2.52,3.92-3.86s6.14,.19,6.14,.19c0,0-1.41,5.25-8.68,8.22-7.27,2.97-11.17-.08-11.17-.08Z"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 866.01,
    cy: 249.36,
    r: 9.28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 836.36,
    cy: 256.85,
    r: 9.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 832.16,
    cy: 254.04,
    r: 3.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 862.24,
    cy: 247.61,
    r: 3.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M832.1,266.23s2.18-2.46,6.51-3.97,7.92,0,7.92,0l-6.37,4.98-8.05-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M859.97,260.44s2.79-3.14,8.32-5.07c5.53-1.93,10.12,0,10.12,0l-8.14,6.37-10.29-1.29Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "aj",
    cx: 927.24,
    cy: 170.51,
    r: 13.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M927.24,161.07c5.2,0,9.44,4.23,9.44,9.44s-4.23,9.44-9.44,9.44-9.44-4.23-9.44-9.44,4.23-9.44,9.44-9.44m0-3.93c-7.38,0-13.37,5.99-13.37,13.37s5.99,13.37,13.37,13.37,13.37-5.99,13.37-13.37-5.99-13.37-13.37-13.37h0Z"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "h",
    "data-name": "bg-alien",
    className: "ab",
    x: 97.13,
    y: 365.35,
    width: 218.94,
    height: 218.94,
    rx: 109.47,
    ry: 109.47,
    transform: "translate(413.21 949.63) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M256.53,444.81c7.57-2.76,13.78-9.03,16.48-16.63,2.7-7.6,1.82-16.38-2.32-23.3-2.8-4.68-6.91-8.41-10.68-12.35-6.05-6.33-14.06-18.71-5.67-26.75,2.96-2.84,7.44-3.12,11.5-3.64,4.06-.53,8.64-1.89,10.29-5.64,1.79-4.09-1.11-9-5.1-11-13.09-6.55-33.99,3.23-36.49,17.96-1.87,10.98,7.58,21.16,13.98,29.09,3.93,4.87,8.09,10.47,7.38,16.69-.81,7.13-7.06,11.42-10.67,17.05-2.58,4.03-2.39,7.64-3.18,12.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M182.96,447.58c-7.57-2.76-13.78-9.03-16.48-16.63-2.7-7.6-1.82-16.38,2.32-23.3,2.8-4.68,6.91-8.41,10.68-12.35,6.05-6.33,14.06-18.71,5.67-26.75-2.96-2.84-7.44-3.12-11.5-3.64s-8.64-1.89-10.29-5.64c-1.79-4.09,1.11-9,5.1-11,13.09-6.55,33.99,3.23,36.49,17.96,1.87,10.98-7.58,21.16-13.98,29.09-3.93,4.87-8.09,10.47-7.38,16.69,.81,7.13,7.06,11.42,10.67,17.05,2.58,4.03,2.39,7.64,3.18,12.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M269.6,470.2c4.49-5.39,6.08-3.27,8.28-9.94s1.59-14.84-3.51-19.65c-3.18-3-8.21-3.89-12.26-2.59-2.22,.71-4.55-.82-4.84-3.13-.75-5.94-4.41-11.57-9.86-14.15-6.54-3.1-14.86-1.41-20.04,3.54-1.52,1.45-3.95,1.35-5.37-.2-5.58-6.09-14.8-8.83-22.72-6.28-6.16,1.98-11.1,7.03-13.45,13.03-.98,2.51-4.22,3.22-6.14,1.34-3.86-3.77-9.41-5.89-14.77-5.05-11.62,4.02-17.59,8.97-15.59,23.54-20.47-7-37.24,1.24-47.33,18.7-6.08,10.52-12.62,23.13-16.59,34.22-4.33,12.1-3.68,31.47,2.07,43.2,6.32,12.89,15.9,21.78,29.72,21.78s20.05-7.6,30.76-23.16c10.71-15.55,12.63-43.82,12.44-45.28,1.35,11.98,3.62,12.51,16.4,26.26,14.62,15.72,54.02,18.45,72.97,8.37,18.95-10.08,19.75-43.09,19.82-64.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 218.91,
    cy: 480.7,
    r: 11.45
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.4,
    cy: 484.68,
    r: 11.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 266.03,
    cy: 480.48,
    r: 4.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 223.19,
    cy: 477.88,
    r: 4.58
  })), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M114.85,511.67c-.58,3.09-.91,6.3-.2,9.37s2.61,5.99,5.48,7.27c4.39,1.96,9.52-.35,13.24-3.39,7.82-6.4,12.56-16,14.65-25.89,2.26-10.68,4.98-36.8-12.05-22.83-10.83,8.88-18.53,21.7-21.11,35.48Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M201.15,488.75s6-3.37,15.59-3.41,15.66,5.41,15.66,5.41l-16.01,5.5-15.24-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M236.71,492.82s6-3.37,15.59-3.41c9.59-.03,15.66,5.41,15.66,5.41l-16.01,5.5-15.24-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.68,515.5c-4.87-2.4-8.92-6.47-11.15-11.41-.79-1.74-.16-3.81,1.58-4.6,.81-.37,10.35,2.74,18.28,4.34,9.06,1.82,18.74,1.24,19.43,1.99,1.31,1.39-.73,4.58-2.12,5.89-5.35,5.02-13.2,7.2-20.48,5.7-1.92-.39-3.78-1.04-5.54-1.91Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M302.78,439.07v-108.02c0-13.14,10.65-23.78,23.78-23.78h92.9c13.47,0,24.25,11.18,23.77,24.64l-1.22,33.68c-.46,12.79-10.97,22.92-23.77,22.92h-89.41l-26.05,50.56Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 396.41,
    cy: 352.68,
    r: 16.89
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 348.15,
    cy: 352.68,
    r: 16.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ad",
    cx: 342.11,
    cy: 350.26,
    r: 2.41
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ad",
    cx: 352.97,
    cy: 350.26,
    r: 2.41
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.89,358.29c-1.43-.42-2.72-1.34-3.56-2.57-.3-.43-.18-1.03,.25-1.32,.43-.29,1.03-.18,1.32,.25,.79,1.17,2.22,1.95,3.64,2,1.44,.05,2.86-.62,3.71-1.75,.32-.42,.91-.5,1.33-.19,.42,.32,.5,.91,.19,1.33-1.22,1.61-3.24,2.57-5.29,2.51-.54-.02-1.08-.11-1.59-.26Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M394.16,358.29c-1.43-.42-2.72-1.34-3.56-2.57-.3-.43-.18-1.03,.25-1.32,.43-.29,1.03-.18,1.32,.25,.79,1.17,2.22,1.95,3.64,2,1.44,.05,2.86-.62,3.71-1.75,.32-.42,.91-.5,1.33-.19,.42,.32,.5,.91,.19,1.33-1.22,1.61-3.24,2.57-5.29,2.51-.54-.02-1.08-.11-1.59-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M392.33,350.05c-.65,.76-1.28,1.56-1.95,2.3-.84-.54-1.66-1.14-2.49-1.7-1.11-.75-2.5-1.98-2.23-3.48,.09-.52,.41-.99,.85-1.27,.44-.28,1-.37,1.51-.23,.68,.18,1.23,.72,1.64,1.31,.24-.68,.63-1.34,1.23-1.7,.45-.27,1.02-.33,1.52-.18,.5,.15,.93,.52,1.16,1,.66,1.38-.36,2.93-1.23,3.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M403.34,350.87c-.83,.56-1.65,1.16-2.49,1.7-.67-.74-1.3-1.54-1.95-2.3-.87-1.02-1.89-2.57-1.23-3.95,.23-.47,.66-.84,1.16-1,.5-.15,1.07-.09,1.52,.18,.6,.35,.99,1.02,1.23,1.7,.41-.59,.96-1.13,1.64-1.31,.51-.14,1.07-.05,1.51,.23,.44,.28,.76,.75,.85,1.27,.27,1.51-1.12,2.73-2.23,3.48Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 273.02,
    cy: 563.06,
    r: 13.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M273.02,553.62c5.2,0,9.44,4.23,9.44,9.44s-4.23,9.44-9.44,9.44-9.44-4.23-9.44-9.44,4.23-9.44,9.44-9.44m0-3.93c-7.38,0-13.37,5.99-13.37,13.37s5.99,13.37,13.37,13.37,13.37-5.99,13.37-13.37-5.99-13.37-13.37-13.37h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M596.1,357.85c-15.01-1.25-40.03,6.25-45.03,2.5-.96-.73-1.38-1.54-1.31-2.4,.06-.01,.3-.02,0-.05-.33-.03-1.26-.05-3.69-.05-4.58,0-9.17,1.05-10.86-3.59-.16-.41-.3-.89-.4-1.41-.84-4.22,2.3-5.59,4.43-6.04,6.67,2.06,14.13,1.39,20.59-3.97,9.19-7.62,5.83-20.33,3.72-25.94-.1-.24-.19-.48-.26-.69,4.74-1.8,26.51-9.64,45.33-9.64,21.27,0,30.02,5,32.52,27.52s-30.02,25.02-45.03,23.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M534.81,352.85c.1,.53,.24,1,.4,1.41-5.85,1.08-10.46,.79-14.16-5.17-3.1-5,2.78-9.22,5.24-10.7,3.36,3.79,7.93,6.87,12.95,8.41-2.13,.45-5.27,1.83-4.43,6.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M559.83,342.84c-6.45,5.35-13.92,6.03-20.59,3.97-5.02-1.54-9.58-4.62-12.95-8.41-.53-.59-1.03-1.19-1.49-1.81-5-6.25-2.5-12.51-2.5-12.51,0,0-8.76-2.5-6.25-12.51,1.25-3.75,11.4,1.64,11.4,1.64,0,0-.14-4.14,11.12-7.89,7.51-2.5,16.26,1.25,16.26,1.25,0,0,6.25-7.51,10.01-5s-2.5,12.51-2.5,12.51c0,0,.4,.79,.95,2.14,.08,.21,.16,.45,.26,.69,2.11,5.62,5.48,18.33-3.72,25.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M535.21,355.51c-.5,0-.97-.3-1.16-.79-.2-.5-.35-1.05-.46-1.64-.76-3.82,1.26-6.62,5.4-7.5,.67-.15,1.34,.29,1.48,.97s-.29,1.34-.96,1.48c-4.19,.89-3.64,3.66-3.46,4.57,.08,.44,.2,.85,.34,1.2,.25,.64-.06,1.37-.71,1.62-.15,.06-.31,.09-.46,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M551.07,361.61c-.26,0-.52-.08-.75-.25-2.05-1.54-1.95-3.34-1.7-4.27,1.16-4.37,9.88-8.3,17.3-9.23,3.51-.44,7.78-.58,12.3-.72,8.55-.27,18.24-.58,26.27-2.99,12.12-3.63,20.88-11.03,20.97-11.11,.53-.45,1.32-.39,1.76,.14,.45,.53,.39,1.32-.14,1.76-.37,.32-9.26,7.82-21.87,11.6-8.35,2.5-18.21,2.82-26.91,3.09-4.46,.14-8.68,.28-12.07,.7-7.71,.96-14.5,4.76-15.2,7.39-.07,.26-.23,.87,.78,1.63,.55,.41,.66,1.2,.25,1.75-.25,.33-.62,.5-1,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M534.14,333.07c-.66,0-1.38-.08-2.14-.28-.67-.17-1.08-.85-.91-1.52s.85-1.08,1.52-.91c3.85,.96,5.34-1.79,5.5-2.11,.31-.62,1.05-.87,1.67-.57,.62,.3,.88,1.04,.58,1.66-.69,1.44-2.77,3.73-6.22,3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M553.61,326.78c-1.21,0-2.01-.23-2.09-.25-.66-.2-1.04-.89-.84-1.56,.2-.66,.89-1.04,1.55-.84,.15,.04,3.58,.96,6.72-2.19,.49-.49,1.28-.49,1.77,0,.49,.49,.49,1.28,0,1.77-2.55,2.55-5.28,3.07-7.1,3.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ad",
    cx: 547.32,
    cy: 334.09,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M552.16,338.1c.24,0,.48,.07,.7,.21,.57,.39,.72,1.16,.34,1.74-.36,.53-.85,.9-1.23,1.16-1.76,1.19-3.9,1.82-6.03,1.82-.69,0-1.24-.57-1.24-1.26,0-.69,.6-1.25,1.26-1.24,1.63,0,3.26-.47,4.6-1.38,.2-.13,.44-.31,.56-.49,.24-.36,.64-.55,1.04-.55Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M447.83,427.95c0,11.48-9.3,20.78-20.78,20.78-3.17,0-6.17-.71-8.86-1.98-1.34-.63-2.6-1.4-3.76-2.29,4.93-3.43,10.55-8.23,15.88-13.56,5.21-5.21,9.88-10.66,13.3-15.5,.89,1.17,1.65,2.43,2.28,3.77,1.25,2.67,1.94,5.65,1.94,8.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M443.61,415.4c-3.41,4.84-8.09,10.29-13.3,15.5-5.33,5.33-10.95,10.13-15.88,13.56h0c-1.34-1.02-2.55-2.21-3.6-3.53-.91-1.13-1.7-2.36-2.36-3.67-1.41-2.8-2.2-5.96-2.2-9.31,0-11.48,9.3-20.78,20.78-20.78,3.32,0,6.46,.78,9.24,2.17,1.31,.65,2.54,1.44,3.68,2.34,1.36,1.08,2.59,2.33,3.64,3.72Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "u",
    cx: 421.08,
    cy: 426.46,
    r: 2.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "y",
    cx: 413.41,
    cy: 425.82,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "y",
    cx: 414.9,
    cy: 420.06,
    r: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M452.36,402.96c-.45-.45-1.12-.67-1.97-.67-2.93,0-8.05,2.61-14.1,7.05,1.31,.65,2.54,1.44,3.68,2.34,.27-.19,.54-.38,.81-.56,3.03-2.07,5.34-3.31,6.97-4,.28-.12,.56,.17,.43,.44-.62,1.31-2.02,4.12-3.73,6.64-.27,.4-.55,.8-.84,1.21-3.41,4.84-8.09,10.29-13.3,15.5-5.33,5.33-10.95,10.13-15.88,13.56h0c-.16,.11-.32,.22-.47,.33-3.06,2.1-5.39,3.34-7.02,4.03-.27,.12-.55-.16-.43-.43,.65-1.53,1.8-3.73,3.79-6.68,.17-.26,.35-.52,.54-.78-.91-1.13-1.7-2.36-2.36-3.67-5.53,7.62-8.08,13.69-6.09,15.68,.45,.45,1.12,.67,1.97,.67,2.89,0,7.91-2.53,13.85-6.86,4.62-3.36,9.8-7.81,14.99-13,5.04-5.04,9.38-10.08,12.71-14.59,5.79-7.86,8.51-14.17,6.47-16.21Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "ab",
    x: 772.11,
    y: 439.9,
    width: 170.65,
    height: 170.65,
    rx: 42.11,
    ry: 42.11,
    transform: "translate(1714.87 1050.45) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "ak"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M806.79,496.61c-7.41-1.97-13.35-8.64-14.46-16.23-.48-3.31-.07-6.84,1.71-9.67,1.79-2.82,5.1-4.78,8.42-4.42,4.05,.44,7.04,3.97,9.11,7.48,3.01,5.09,5.07,10.72,6.07,16.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M870.89,490.96c.08-6.83,2.36-13.61,6.43-19.1,1.87-2.53,4.27-4.88,7.32-5.63,4.68-1.15,9.71,2.08,11.53,6.54,1.82,4.46,.84,9.69-1.57,13.86-2.42,4.16-6.12,7.42-9.97,10.31-3.85,2.9-7.91,5.53-11.41,8.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M967.9,577.21c-1.08,9.08-6.16,16.03-15.99,17.08-11.13,1.2-22.44-2.84-30.14-10.95-5.17-5.44-8.54-12.18-11.31-19.22-.98-2.5-4.4-2.62-5.63-.22-5.81,11.32-21.73,19.33-34.67,22.5-16.17,3.96-33.59,2.58-48.92-3.86-7.43-3.13-16.24-7.83-19.73-14.96-1.11-2.27-4.28-2.38-5.49-.16-7.15,13.22-15.02,16.43-27.27,18.18-14.68,2.1-19.99-3.02-25.86-9.27-6.35-6.77-5.77-17.62-2.37-26.28,5.53-14.09,17.71-25.39,32.12-30.02,1.64-.53,2.5-2.26,1.97-3.9-2.25-6.93-1.73-12.74,4.36-16.22,6.09-3.48,10.44-4.35,17.85-.6,1.54,.84,3.5,.19,4.22-1.41,2.39-5.31,6.25-9.97,11.06-13.23,6.12-4.15,14.2-6,21.03-3.21,3.49,1.43,6.53,3.51,8.32,6.13,1.63,2.37,4.9,2.9,7.12,1.08,1.01-.83,2.14-1.67,3.41-2.64,4.49-3.4,10.38-5.18,15.85-3.84,5.75,1.4,9.85,5.73,13.06,10.89,2.82,4.53,8.39,6.46,13.46,4.81,1.36-.44,2.76-.76,4.2-.91,4.68-.5,7.69-.53,10.87,2.93,2.3,2.5,4.6,7.52,3.6,10.81-.5,1.66,.39,3.41,2.06,3.85,5.63,1.49,15.7,5.68,17.18,6.32,7.03,3.07,13.79,7.03,19.44,12.27,11.29,10.46,17.2,26.85,16.36,42.07-.04,.67-.09,1.33-.17,1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M917.86,553.69c2.48,4.59,5.12,9.36,9.9,11.82,2.02,1.04,4.35,1.47,6.58,1.07,6.97-1.26,8.03-8.81,5.32-13.8-2.06-3.8-5.78-6.38-9.55-8.49-4.55-2.54-9.89-5.15-15.21-6.56-2.79-.74-5.13,2.09-3.85,4.67,1.99,4.04,5.3,8.48,6.82,11.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M757.12,547.77c-2.21,2.42-4.25,5.13-5.08,8.29-.83,3.17-.2,6.89,2.26,9.05,2.91,2.56,7.56,2.19,10.85,.14,3.29-2.05,5.49-5.43,7.45-8.77,2.05-3.5,3.96-7.14,4.86-11.09,.3-1.33,.28-3.65-.15-6.17-.55-3.18-4.23-4.75-6.87-2.89-4.83,3.42-10.24,8.08-13.31,11.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.51,542.32c-2.85-.84-5.4-2.65-7.06-5.11-.59-.86-.36-2.04,.51-2.62,.86-.58,2.03-.36,2.62,.51,1.57,2.31,4.4,3.87,7.22,3.96,2.85,.09,5.67-1.24,7.36-3.47,.63-.83,1.81-1,2.64-.37,.83,.63,1,1.81,.37,2.64-2.41,3.2-6.43,5.1-10.49,4.97-1.07-.03-2.13-.21-3.16-.51Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 863.56,
    cy: 516.52,
    r: 10.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 823.88,
    cy: 520.24,
    r: 10.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 820.78,
    cy: 515.86,
    r: 4.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 859.41,
    cy: 513.43,
    r: 4.28
  }))), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M803.87,629.52c.08,29.8,26,17.79,26,17.79,0,0,56.79,7.53,56.79-14.37,0-38.32-7.31-40.27-16.42-48.58-16.22-14.79-19.51-15.73-40.37-8.89-20.86,6.84-26.08,24.25-26,54.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M837.37,656.92c-5.25,6.38-11.41,12.05-18.2,16.75-3.98,2.75-8.51,5.25-13.36,5.03-1.03-.05-2-.24-2.92-.49-.54-.14-1.07-.32-1.57-.53-4.81-1.89-8.77-6.21-12.23-10.27-1.86-2.2-3.87-4.74-3.63-7.6,.28-3.36,3.54-5.76,6.86-6.35,2.16-.42,4.38-.23,6.54,.05,1.11,.11,2.2,.29,3.27,.39,.05,0,.14,.01,.19,.02,9.47,.88,19.23-1.52,27.14-6.77l7.91,9.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M876.24,640.94c2.46,.37,4.26,2.5,4.26,4.99,0,6.81-.76,13.64-2.28,20.28-1.09,4.71-2.76,9.61-6.49,12.72-.8,.66-1.64,1.17-2.49,1.61-.49,.26-1.01,.48-1.52,.67-4.82,1.84-10.66,1.32-15.96,.64-2.85-.37-6.05-.9-7.8-3.18-2.06-2.67-1.26-6.64,.8-9.32,1.32-1.77,3.08-3.12,4.87-4.37,.9-.67,1.82-1.27,2.68-1.92,.04-.03,.11-.08,.15-.11,5.61-4.23,10.13-9.89,13.04-16.27,1.87-4.1,6.28-6.43,10.74-5.75h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M877.23,575.47v72.85c0,6.69-5.42,12.11-12.11,12.11h-42.99c-6.69,0-12.11-5.42-12.11-12.11v-72.85h67.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M880.29,567.26c0,1.04-.22,2.08-.56,3.06-.21,.6-2.06,5.17-2.65,5.15-5.4-.11-10.84,0-16.25,0h-30.94c-6.51,0-13.01,0-19.52,0-.02,0-.33,.01-.34,0-.74-2.7-2.54-5.55-2.26-8.39s1.7-5.36,3.92-7c3.58-2.65,7.35-1.69,11.34-1.03,.7,.12,2.91-2.85,3.43-3.44,1.91-2.17,5.02-3.11,7.82-2.35,3.62,.99,4.57,4.1,5.94,7.19,1.98-1.45,4.01-2.93,6.35-3.67,2.25-.71,4.8-.45,6.76,.89,2.04,1.38,2.45,3.66,3.09,5.88-.6-2.11,4.25-5.88,10.4-5.88,4.79,0,11.48,1.74,13.21,7.68,.18,.62,.26,1.26,.26,1.91Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 817.97,
    y: 581.63,
    width: 4.79,
    height: 73.21,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 829.6,
    y: 581.63,
    width: 4.79,
    height: 73.21,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 841.24,
    y: 581.63,
    width: 4.79,
    height: 73.21,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 852.87,
    y: 581.63,
    width: 4.79,
    height: 73.21,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "l",
    x: 864.5,
    y: 581.63,
    width: 4.79,
    height: 73.21,
    rx: 1.9,
    ry: 1.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "j",
    x1: 966.17,
    y1: 561.39,
    x2: 964.56,
    y2: 561.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M804.3,608.95c-.45,.19-.97-.03-1.16-.48l-.49-1.17c-.19-.45,.03-.97,.48-1.16"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M888.76,604.76c-6.59,1.48-8.14,1.75-16.01,1.6-3.9-.07-8.28,.39-11.1-2.3-1.85-1.77-3.59-4.17-3.67-6.73-.06-2.08-.74-4.96-3.29-5.16-1.83-.14-2.92,1.77-2.89,3.05,.05,2.05-1.12,4.01-3.05,2.43-1.65-1.35-5.13-5.88-6.55-6.32-2.8-.88-6.52,.53-6.94,3.44-.43,2.97,2.49,5.18,4.28,7.59-1.72-1.34-3.72-2.32-5.83-2.89-3.05-.82-5.72,2.25-4.48,5.15,.92,2.13,2.63,2.78,4.21,4.51-1.66-.52-3.37-1.05-5.1-.9s-3.62,1.1-4.06,2.78c-.96,3.74,3.8,5.74,8.58,7.33,4.79,1.59,5.59,3.43,7.79,5.09,3.74,2.83,6.89,4.54,14.02,3.93,10.45-.91,23.25-5.16,37.56-9.76,4.69-1.51,4.36-5.66,3.13-9.33-1.22-3.68-4.36-4-6.62-3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M792.75,598.94c6.75,.23,19.48,3.43,27.19,1.84,3.82-.79,8.21-1.14,10.48-4.31,1.49-2.08,2.76-4.76,2.36-7.29-.33-2.06-.19-5.01,2.28-5.68,1.77-.47,3.2,1.2,3.4,2.47,.33,2.02,1.84,3.73,3.44,1.82,1.37-1.63,3.95-6.72,5.27-7.43,2.59-1.38,6.51-.68,7.46,2.1,.97,2.84-1.49,5.55-2.8,8.25,1.45-1.64,3.23-2.97,5.2-3.92,2.85-1.37,6.04,1.15,5.35,4.24-.51,2.27-2.07,3.22-3.3,5.21,1.53-.82,3.11-1.65,4.84-1.83s3.77,.41,4.5,1.98c1.64,3.5-2.67,6.34-7.08,8.79s-4.86,4.4-6.72,6.44c-3.16,3.47-5.93,5.74-13.05,6.45-10.43,1.04-31.81-.52-46.72-2.4-4.89-.62-9.72-4.94-9.2-8.78s4.79-8.03,7.11-7.95Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M796.02,567.42c-7.15,13.22-15.02,16.43-27.27,18.18-14.68,2.1-19.99-3.02-25.86-9.27-6.35-6.77-5.77-17.62-2.37-26.28,5.53-14.09,17.71-25.39,32.12-30.02,1.64-.53,2.5-2.26,1.97-3.9-2.25-6.93-1.73-12.74,4.36-16.22,6.09-3.48,10.44-4.35,17.85-.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M757.12,547.77c-2.21,2.42-4.25,5.13-5.08,8.29-.83,3.17-.2,6.89,2.26,9.05,2.91,2.56,7.56,2.19,10.85,.14,3.29-2.05,5.49-5.43,7.45-8.77,2.05-3.5,3.96-7.14,4.86-11.09,.3-1.33,.28-3.65-.15-6.17-.55-3.18-4.23-4.75-6.87-2.89-4.83,3.42-10.24,8.08-13.31,11.44Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "ag",
    cx: 925.66,
    cy: 446.98,
    r: 13.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M925.66,437.54c5.2,0,9.44,4.23,9.44,9.44s-4.23,9.44-9.44,9.44-9.44-4.23-9.44-9.44,4.23-9.44,9.44-9.44m0-3.93c-7.38,0-13.37,5.99-13.37,13.37s5.99,13.37,13.37,13.37,13.37-5.99,13.37-13.37-5.99-13.37-13.37-13.37h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M794.47,246.27l184.34,334.5c27.06,49.1-8.46,109.23-64.52,109.23H164.01c-56.58,0-92.04-61.14-63.95-110.25L293.78,241.11c6.55-12.01,19.13-19.48,32.81-19.48h427.43c17.03,0,32.64,9.51,40.45,24.64Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlocksWatchTv);
export default __webpack_public_path__ + "static/media/Flocks_Watch_TV.c5892bd297a36ed034a257ba42397dc1.svg";
export { ForwardRef as ReactComponent };